import { useQuery } from '@tanstack/react-query';
import { api, ApiError, getAccessToken } from './api';
import type { User } from '@superp/shared';

export function useCurrentUser() {
  const hasToken = !!getAccessToken();
  return useQuery({
    queryKey: ['me'],
    enabled: hasToken,
    staleTime: 5 * 60_000,
    queryFn: async () => {
      try {
        const res = await api<{ user: User }>('/auth/me');
        return res.user;
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
  });
}
